
// echarts options

// 仪表盘 options
export const gaugeBaseOption = {
  backgroundColor: 'transparent',
  splitNumber: 12,
  series: [
    {
      type: 'gauge',
      min: 0,
      radius: '100%',
      progress: {
        show: true,
        roundCap: true,
        width: 5,
      },
      pointer: {
        width: 4,
      },
      axisLine: {
        roundCap: false,
        lineStyle: {
          width: 5,
        },
      },
      axisTick: {
        distance: 3,
        splitNumber: 4,
        length: 2,
        lineStyle: {
          width: 0.5,
        },
      },

      splitLine: {
        length: 2,
        lineStyle: {
          width: 1,
        },
      },
      axisLabel: {
        distance: 3,
        fontSize: 12,
      },
      title: {
        show: false,
      },
      detail: {
        backgroundColor: 'transparent',
        borderColor: '#fff',
        width: '60%',
        lineHeight: 40,
        height: 40,
        borderRadius: 8,
        offsetCenter: [0, '30%'],
        valueAnimation: true,
        rich: {
          value: {
            fontWeight: 'bolder',
          },
          unit: {
            fontWeight: 'bolder',
          },
        },
      },
      data: [
        {
          name: '',
        },
      ],
    },
  ],

}

// 饼图 options
export const pieBaseOption = {
  title: {
    show: false,
  },
  tooltip: {
    show: true,
    trigger: 'item',
    backgroundColor: 'rgba(0, 0, 0,.7)',
    borderColor: 'transparent',
    textStyle: {
      color: '#fff',
    },
    position: (point, params, dom, rect, size) => {
      const viewSizeW = size.viewSize[0]
      const viewSizeH = size.viewSize[1]
      const tooltipW = size.contentSize[0]
      const tooltipH = size.contentSize[1]
      const pointX = point[0]
      const pointY = point[1]
      let x, y
      if (pointX + tooltipW <= viewSizeW) {
        x = pointX
      } else {
        x = viewSizeW - tooltipW
      }
      if (pointY + 10 + tooltipH <= viewSizeH) {
        y = pointY + 10
      } else {
        y = viewSizeH - tooltipH
      }
      return [x, y]
    },

  },
  legend: {
    top: '2%',
    width: '90%',
    align: 'left',
    textStyle: {
      color: '#D0D5E0',
      lineHeight: 12,
      rich: {
        a: {
          verticalAlign: 'middle',
        },
      },
      padding: [0, 0, -4, 0],
    },
    itemWidth: 10,
    itemHeight: 8,

  },
  series: [
    {
      top: '10%',
      bottom: '5%',
      left: '2%',
      right: '2%',
      name: '',
      type: 'pie',
      center: ['50%', '50%'], // 设置饼图位置
      avoidLabelOverlap: true, // 防止标签重叠
      label: {
        color: '#D0D5E0',
      },
      labelLine: {
        length: 25,
        length2: 20,
      },
      emphasis: {
        label: {
          fontSize: 13,
        },
        labelLine: {
          show: true,
        },
      },
    },
  ],
}

// 地图 option
export const mapBaseOption = {
  tooltip: {
    show: true,
    trigger: 'item',
    axisPointer: {
      lineStyle: {
        color: '#D0D5E0',
      },
    },
    backgroundColor: 'rgba(0, 0, 0,.6)',
    borderColor: 'transparent',
    textStyle: {
      color: '#fff',
    },

    position: (point, params, dom, rect, size) => {
      const viewSizeW = size.viewSize[0]
      const viewSizeH = size.viewSize[1]
      const tooltipW = size.contentSize[0]
      const tooltipH = size.contentSize[1]
      const pointX = point[0]
      const pointY = point[1]
      let x, y
      if (pointX + tooltipW <= viewSizeW) {
        x = pointX
      } else {
        x = viewSizeW - tooltipW
      }
      if (pointY + 10 + tooltipH <= viewSizeH) {
        y = pointY + 10
      } else {
        y = viewSizeH - tooltipH
      }
      return [x, y]
    },
  },
  series: [
    {
      name: '',
      type: 'map',
      geoIndex: 0,
      coordinateSystem: 'geo',
    },
  ],
  geo: {
    aspectScale: 0.75,
    select: 'disable',
    layoutSize: '100%',
    layoutCenter: ['50%', '50%'], // 设置后left/right/top/bottom等属性无效
    roam: false, // 是否开启鼠标缩放和平移漫游
    label: {
      color: '#ccc',
      opacity: 1,
    },
    emphasis: {
      label: {
        show: true,
        color: '#fff',
        opacity: 1,
      },
      itemStyle: {
        show: true,
        opacity: 1,
      },
    },
    itemStyle: {
      borderWidth: 1, // 边际线大小
      opacity: 0.3,
    },
  },
}

// 折线 option
export const lineBaseOption = {
  animation: false,
  grid: {
    left: '3%',
    right: '3%',
    bottom: '10%',
    containLabel: true,
  },
  legend: {
    top: '2%',
    width: '90%',
    align: 'left',
    right: '3%',
    textStyle: {
      color: '#fff',
    },
    itemWidth: 14,
    itemHeight: 10,
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      lineStyle: {
        color: '#D0D5E0',
      },
    },
    backgroundColor: 'rgba(0, 0, 0,.7)',
    borderColor: 'transparent',
    textStyle: {
      color: '#fff',
    },
    position: (point, params, dom, rect, size) => {
      const viewSizeW = size.viewSize[0]
      const viewSizeH = size.viewSize[1]
      const tooltipW = size.contentSize[0]
      const tooltipH = size.contentSize[1]
      const pointX = point[0]
      const pointY = point[1]
      let x, y
      if (pointX + tooltipW <= viewSizeW) {
        x = pointX
      } else {
        x = viewSizeW - tooltipW
      }
      if (pointY + 10 + tooltipH <= viewSizeH) {
        y = pointY + 10
      } else {
        y = viewSizeH - tooltipH
      }
      return [x, y]
    },

  },
  xAxis: {
    type: 'category',
    nameLocation: 'middle',
    // 填充数据
    axisLabel: {
      color: '#D0D5E0',
    },
    axisTick: {
      show: false,
    },
  },
  yAxis: [
    {
      type: 'value',
      splitNumber: 6,
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#323C4C',
        },
      },
      axisLabel: {
        color: '#D0D5E0',
      },
    },
    {
      type: 'value',
      splitNumber: 6,
      splitLine: {
        show: false,
      },
      axisLabel: {
        color: '#D0D5E0',
      },
    },
  ],
  label: {
    position: 'top',
    color: '#D0D5E0',
  },

}

// 柱状图 baseOption
const barBaseOption = {
  grid: {
    left: '3%',
    right: '3%',
    bottom: '5%',
    top: '10%',
    containLabel: true,
  },
  legend: {
    top: '2%',
    width: '90%',
    align: 'left',
    right: '3%',
    textStyle: {
      color: '#fff',
    },
    itemWidth: 14,
    itemHeight: 10,
  },
  tooltip: {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    backgroundColor: 'rgba(0, 0, 0,.7)',
    borderColor: 'transparent',
    textStyle: {
      color: '#fff',
    },

  },
}

// 垂直柱状图 option
export const verticalBarBaseOption = {
  ...barBaseOption,
  animation: false,
  grid: {
    left: '3%',
    right: '4%',
    bottom: '5%',
    containLabel: true,
  },
  legend: {
    top: '1%',
    right: '4%',
    textStyle: {
      color: '#D0D5E0',
      lineHeight: 12,
    },
    itemWidth: 14,
    itemHeight: 10,

  },
  xAxis: {
    type: 'category',
    axisLabel: {
      color: '#D0D5E0',
    },
    axisTick: {
      show: false,
    },
    axisLine: { // 坐标轴
      lineStyle: {
        color: '#323C4C',
      },
    },
  },

  yAxis: {
    type: 'value',
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#323C4C',
      },
    },
    axisLine: { show: false },
    axisLabel: {
      color: '#A3A2AD',
    },
  },
}

// 水平柱状图 option
export const horizonBarBaseOption = {
  ...barBaseOption,
  grid: {
    left: '3%',
    right: '12%',
    bottom: '5%',
    top: '3%',
    containLabel: true,
  },
  yAxis: {
    type: 'category',
    axisLabel: {
      color: '#D0D5E0',
    },
    axisTick: {
      show: false,
    },
    axisLine: { // 坐标轴
      lineStyle: {
        color: '#323C4C',
      },
    },

    inverse: true, // 反向坐标轴
  },

  xAxis: {
    type: 'value',
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#323C4C',
      },
    },
    axisLine: { show: false },
    axisLabel: {
      color: '#A3A2AD',
    },
  },
}

// 环形柱状图 option
export const polarBarBaseOption = {
  ...barBaseOption,
  tooltip: {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    backgroundColor: 'rgba(0, 0, 0,.7)',
    borderColor: 'transparent',
    textStyle: {
      color: '#fff',
    },
    position: (point, params, dom, rect, size) => {
      const viewSizeW = size.viewSize[0]
      const viewSizeH = size.viewSize[1]
      const tooltipW = size.contentSize[0]
      const tooltipH = size.contentSize[1]
      const pointX = point[0]
      const pointY = point[1]
      let x, y
      if (pointX + tooltipW <= viewSizeW) {
        x = pointX
      } else {
        x = viewSizeW - tooltipW
      }
      if (pointY + 10 + tooltipH <= viewSizeH) {
        y = pointY + 10
      } else {
        y = viewSizeH - tooltipH
      }
      return [x, y]
    },
  },
  polar: {
    center: ['50%', '50%'],
  },
  angleAxis: {
    startAngle: 75,
    axisLabel: {
      show: true,
      color: '#A3A2AD',
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#A3A2AD',
      },
    },
  },
  radiusAxis: {
    type: 'category',
    axisLabel: {
      color: '#A3A2AD',
    },
  },
}

/**
 * 榜单 Y 轴标签 rich：奖牌占位 + 名称样式（普通行 / Top N 行可不同颜色、字号、加粗）
 * @param {number|object} opts 兼容旧调用：仅传 fontSize；或 { fontSize, labelColor, topLabelColor, topLabelFontSize, topLabelBold }
 */
export function buildRankYAxisLabelRich (opts) {
  const o = typeof opts === 'number' ? { fontSize: opts } : (opts || {})
  const fs = Number(o.fontSize) > 0 ? Number(o.fontSize) : 12
  const topFs = Number(o.topLabelFontSize) > 0 ? Number(o.topLabelFontSize) : fs
  const labelColor = o.labelColor != null && o.labelColor !== '' ? o.labelColor : '#D0D5E0'
  const topColor =
    o.topLabelColor != null && o.topLabelColor !== '' ? o.topLabelColor : labelColor
  const topBold = !!o.topLabelBold
  const h = Math.max(12, Math.round(fs * 1.4))
  const hTop = Math.max(12, Math.round(topFs * 1.4))
  const rowH = Math.max(h, hTop)
  const wMedal = Math.max(14, Math.round((rowH * 20) / 18))
  const wOther = Math.max(12, rowH)
  const textBase = {
    align: 'right',
    verticalAlign: 'middle',
    padding: [0, 6, 0, 0],
  }
  return {
    txtTop: {
      ...textBase,
      color: topColor,
      fontSize: topFs,
      fontWeight: topBold ? 'bold' : 'normal',
      height: rowH,
    },
    txtOther: {
      ...textBase,
      color: labelColor,
      fontSize: fs,
      height: rowH,
    },
    a1: {
      height: rowH,
      width: wMedal,
      backgroundColor: { image: require('@/assets/first.png') },
    },
    a2: {
      height: rowH,
      width: wMedal,
      backgroundColor: { image: require('@/assets/second.png') },
    },
    a3: {
      height: rowH,
      width: wMedal,
      backgroundColor: { image: require('@/assets/third.png') },
    },
    other: {
      height: rowH,
      width: wOther,
    },
  }
}

// 排行榜 option
export const rankBaseOption = {
  grid: {
    left: 30,
    top: '2%',
    bottom: 10,
    containLabel: true,
  },
  tooltip: {
    show: true,
    trigger: 'item',
    backgroundColor: 'rgba(0, 0, 0,.7)',
    borderColor: 'transparent',
    textStyle: {
      color: '#fff',
    },
    position: (point, params, dom, rect, size) => {
      const viewSizeW = size.viewSize[0]
      const viewSizeH = size.viewSize[1]
      const tooltipW = size.contentSize[0]
      const tooltipH = size.contentSize[1]
      const pointX = point[0]
      const pointY = point[1]
      let x, y
      if (pointX + tooltipW <= viewSizeW) {
        x = pointX
      } else {
        x = viewSizeW - tooltipW
      }
      if (pointY + 10 + tooltipH <= viewSizeH) {
        y = pointY + 10
      } else {
        y = viewSizeH - tooltipH
      }
      return [x, y]
    },
  },
  yAxis: {
    type: 'category',
    axisLabel: {
      color: '#D0D5E0',
      left: '0%',
      // formatter 必须；名称走 txtTop/txtOther，实际样式由 rank.vue 注入的 rich 决定
      formatter: (params, index) => {
        const safe = String(params ?? '').replace(/\{/g, '（').replace(/\}/g, '）')
        if (index > 2) {
          return [`{txtOther|${safe}}  {other|}`]
        }
        return [`{txtTop|${safe}}  {a${index + 1}|}`]
      },
      // rich 与 formatter 由 rank.vue init 覆盖（Top N 与饼图 pieLabelTopN 逻辑一致）
      align: 'right', // 文字左排序
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    inverse: true, // 反向坐标轴
  },
  xAxis: {
    type: 'value',
    show: false,
  },
  series: [
    {
      type: 'bar',
      barGap: '120%',
      barWidth: 10,
      itemStyle: {
        borderRadius: 100,
      },
      emphasis: {
        itemStyle: {
          shadowColor: '#fff',
          shadowBlur: 2.5,
        },
      },
      zlevel: 1,
    },
    {
      tooltip: {
        show: false,
      },
      type: 'bar',
      barGap: '-100%',
      barWidth: 10,
      color: '#4D4D4D',
      label: {
        show: true,
        position: 'right',
        color: '#D0D5E0',
      },
      itemStyle: {
        borderRadius: 10,
      },
    },
  ],

}

export const heatMapOption = {
  animation: false,
  amap: {
    roam: 'scale',
  },
  series: [
    {
      name: 'normal',
      type: 'scatter',
      coordinateSystem: 'amap',
      symbolSize: function (val) {
        return val[2] / 10
      },
      encode: {
        value: 2,
      },
      label: {
        formatter: '{b}',
        position: 'right',
      },
      emphasis: {
        label: {
          show: true,
        },
      },
    },
    // 高亮
    {
      name: 'Top 5',
      type: 'effectScatter',
      coordinateSystem: 'amap',
      symbolSize: function (val) {
        return val[2] / 10
      },
      encode: {
        value: 2,
      },
      showEffectOn: 'render',
      rippleEffect: {
        brushType: 'stroke',
      },
      label: {
        formatter: '{b}',
        position: 'right',
        show: true,
      },
      itemStyle: {
        shadowBlur: 10,
        shadowColor: '#333',
      },
      emphasis: {
        scale: true,
      },
      zlevel: 1,
    },
  ],
}
